import type { Configuration, IRequest } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { BatchAddress } from './Definitions/Types';
import { batchGeocodeTransformer } from './geocodeTransformer';

export interface LatLng {
  lat: number;
  lng: number;
}

export class GeocodeRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getRequester = () => this.requester;

  public getAddresses = (latlng: LatLng[]): Promise<string[]> => {
    const requestData: IRequest = {
      endpoint: '/geocoder',
      method: HttpMethod.POST,
      body: JSON.stringify({ to_geocode: latlng }),
    };
    return this.requester.request(requestData).then((response) => response.data.addresses);
  };

  public geocodeFromAddress = (address: string): Promise<LatLng> => {
    const requestData: IRequest = {
      endpoint: `/geocoder?address=${address}`,
      method: HttpMethod.GET,
    };
    return this.requester.request(requestData).then((response) => response.data.location);
  };

  public getAddress = (latLng: LatLng, disableCache?: boolean): Promise<string> => {
    const disableCacheQueryParam = disableCache ? '&disable_cache=true' : '';
    const requestData: IRequest = {
      endpoint: `/geocoder?reverse=true&lat=${latLng.lat}&lng=${latLng.lng}${disableCacheQueryParam}&requester_name=herbie-dashboard`,
      method: HttpMethod.GET,
    };
    return this.requester.request(requestData).then((response) => response.data.address);
  };

  public getLatLngFromAddresses = (addresses: string[]): Promise<BatchAddress[]> => {
    const body = {
      origin: 'routing',
      addresses,
    };
    const requestData: IRequest = {
      endpoint: '/geocoder/places',
      method: HttpMethod.POST,
      body: JSON.stringify(body),
    };
    return this.requester.request(requestData).then((response) => batchGeocodeTransformer(response.data, addresses));
  };
}
